import { useWindowSize } from "../hooks/useWindowSize";
import useMediaQuery from "./useMediaQuery";

export const videoFrames = 101;
export const frameRate = 1000 / 30;
export const freezeScreen = 1;

export const useHeroFreezeFrameHeight = () => {
  const { height } = useWindowSize();
  return height * freezeScreen;
};

export const useHeroSectionHeight = () => {
  const { height } = useWindowSize();
  const md = useMediaQuery("(min-width: 768px)");
  return (md ? 5 : 3) * height + useHeroFreezeFrameHeight();
};
